import { createContext } from 'react';

export type DropZoneContextProps = {
  acceptedMimeTypes?: string[];
  allowsMultiple?: boolean;
  maxFileSize?: number;
  onDropFiles?: (files: File[]) => void;
};

export const DropZoneContext = createContext<DropZoneContextProps>({});
